
import Chart from 'react-apexcharts';
import React, { useEffect } from 'react';
import { BarChart } from '@mui/x-charts/BarChart';

export const SalesSummaryBarChart1 = ({ data = {} }) => {
    const categories = data.categories || [];
    const series = data.series || [];
    useEffect(() => {
        // Give it a slight delay to ensure DOM has rendered
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 300); // adjust delay if needed
    }, []);

    return (
        <Chart
            type="bar"
            height="100%"
            width="100%"
            series={series}
            options={{
                chart: { type: 'bar' },
                xaxis: {
                    categories: categories,
                    title: { text: "Status" }
                },
                yaxis: {
                    title: { text: "Booking" }
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        columnWidth: "25%"
                    }
                },
                colors: ['#79A7FB'],
                dataLabels: { enabled: false },
                title: {
                    text: "Day Wise Booking",
                    align: "center",
                    style: { fontSize: "16px", fontWeight: "bold" }
                }
            }}
        />
    );
};

export const SalesSummaryBarChart = ({ data = {} }) => {
    const categories = data.categories || [];
    const series = data.series || [];
    const chartSeries = series.map((s) => ({
        data: s.data,
        label: s.name,
    }));

    useEffect(() => {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 300);
    }, []);

    return (
        <BarChart
            height={300}
            series={chartSeries}
            xAxis={[
                {
                    scaleType: 'band',
                    data: categories,
                    label: 'Status',
                    categoryGapRatio: 0.8, 
                    barGapRatio: 0.2,
                },
            ]}
            yAxis={[
                {
                    label: 'Total Order',
                    tickMinStep: 1, 
                },
            ]}
            colors={['#79A8FC', '#FF9800', '#F44336']}
            slotProps={{
                legend: {
                    position: { vertical: 'top', horizontal: 'center' },
                },
            }}
        />
    );
};

export const SupplySummaryDonutChart = ({ data = {} }) => {
    const labels = data.labels || ['Supplied', 'Pending', 'Cancelled'];
    const series = data.series || [44, 30, 26];

    return (
        <Chart
            type="donut"
            height="100%"
            width="100%"
            series={series}
            options={{
                chart: { type: 'donut' },
                labels: labels,
                colors: ['#00BFFF', '#FFD700', '#FF6347'],
                title: {
                    text: 'Supply Summary',
                    align: 'center',
                    style: { fontSize: '16px', fontWeight: 'bold' }
                },
                legend: { position: 'bottom' },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: { width: 280 },
                            legend: { position: 'bottom' }
                        }
                    }
                ]
            }}
        />
    );
};

export const OperationLineChart = ({ data = {} }) => {
    const categories = data.categories || ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const series = data.series || [{ name: 'Trips', data: [12, 18, 15, 22, 19, 25, 21] }];

    return (
        <Chart
            type="line"
            height="300px"
            width="100%"
            series={series}
            options={{
                chart: {
                    type: 'line',
                    zoom: { enabled: false }
                },
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                xaxis: {
                    categories: categories,
                    title: { text: 'Day of Week' }
                },
                yaxis: {
                    title: { text: 'Trips' }
                },
                colors: ['#28A745'],
                dataLabels: { enabled: false },
                markers: {
                    size: 4,
                    colors: ['#D9534F'],
                    strokeWidth: 2,
                    hover: { size: 6 }
                },
                title: {
                    text: 'Daily Trips Completed',
                    align: 'center',
                    style: { fontSize: '16px', fontWeight: 'bold' }
                },
                legend: { position: 'bottom' }
            }}
        />
    );
};

export const AccountSummaryPieChart = ({ data = {} }) => {
    const labels = data.labels || [];
    const series = data.series || [];

    return (
        <Chart
            type="pie"
            height="100%"
            width="100%"
            series={series}
            options={{
                chart: { type: 'pie' },
                labels: labels,
                colors: ['#FE001B', '#028014', '#4454ED', '#BDB7B7','#FEA52A'],
                legend: { position: 'bottom' },
                title: {
                    text: 'Pickup Status',
                    align: 'center',
                    style: { fontSize: '16px', fontWeight: 'bold' }
                },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: { width: 280 },
                            legend: { position: 'bottom' }
                        }
                    }
                ]
            }}
        />
    );
};
